import API from "./api";
import Settings from "./settings";

/**
 *  ABRLookup class that interacts with the DataTools Kleber API
 *  to return and prefill business data from the Australian Business Register, via DataTools.
 */
class AbrLookupByBusinessName {

	/**
	 * Autocomplete class constructor
	 *
	 * @param {HTMLElement} container
	 * @param {HTMLElement} field
	 * @param {Object} selectors
	 */
	constructor(container, field, selectors) {
		this.container = container;
		this.field = field;
		this.selectors = selectors;
		this.queryCache = [];
	}

	/**
	 * Initialise the ABR autocomplete field
	 */
	init() {
		const _this = this;

		// Ensure that the container and input elements exist in the DOM
		if (this.container === null || this.field === null) {
			return;
		}

		API.init();
		API.setAbrAuthenticationGuid();

		const $input = jQuery(this.field);
		let queryCache = this.queryCache;

		const close = function () {
			$input.autocomplete("close");
		};

		//Attach the jQuery autocomplete field to the input
		$input.autocomplete({
			html: true,
			minLength: 4,
			source: function (request, response) {

				// Check if we've searched this same query before and return results if so
				// to avoid a repeat API call.
				if ( typeof queryCache[request.term] !== 'undefined' ) {
					response(queryCache[request.term]);
				}

				API.retrieveBusinessInfoByBusinessName(request.term).then(function (data) {
					let results = [];

					if (data.DtResponse.Result.length > 0) {
						let actualResults = data.DtResponse.Result;
						if (!Settings.areInactiveAbrRecordsIncluded()) {
							actualResults = data.DtResponse.Result.filter(item => item.Status === 'Active');
						}
						results = actualResults.map(function (item) {
							let Output = (item.BusinessName + ", " + item.ABN + ", " + item.State + ", " + item.Postcode);
							if (Settings.areInactiveAbrRecordsIncluded()) {
								Output = (item.BusinessName + ", " + item.ABN + ", " + item.State + ", " + item.Postcode + ", " + item.Status);
							}
							return {
								label: Output,
								value: item.BusinessName,
								business: item,
							};
						});
					}

					results.push({
						label: "<b>Don't see your company?</b> Search again or <span class=\"manual-entry\">enter a company manually</span>.",
						value: "dont_see_company"
					});

					// Cache this query in memory for faster responses.
					queryCache[request.term] = results;

					response(results);

				}, () => close);
			},

			select: function (event, ui) {
				event.preventDefault();

				const updateValue = function ($element, value) {
					if ($element.length > 0) {
						$element.val(value);
						$element[0].dispatchEvent(new Event('change'));
					}
				};

				const updateField = function (selector, value) {
					const $element = jQuery(selector);
					updateValue($element, value);
				};

				if (ui.item.value === 'dont_see_company') {
					$input.autocomplete("close");
					updateValue($input, "");
					return;
				} else {
					updateValue($input, ui.item.business.BusinessName);
				}

				const business = ui.item.business;
				const mappings = [
					{
						selector: _this.selectors.BusinessName,
						value: business.BusinessName,
					},
					{
						selector: _this.selectors.ABN,
						value: business.ABN,
					},
					{
						selector: _this.selectors.State,
						value: business.State,
					},
					{
						selector: _this.selectors.Postcode,
						value: business.Postcode,
					},
					{
						selector: _this.selectors.Status,
						value: business.Status,
					},
				];

				mappings.forEach(mapping => updateField(mapping.selector, mapping.value));
			}
		});
	}
}

export default AbrLookupByBusinessName;
